<template>

  <TransitionExpand>
    <div class="elevation-4" v-if="enabled">
      <v-toolbar flat="flat">
        <v-toolbar-title>Search</v-toolbar-title>
      </v-toolbar>
      <v-container fluid="fluid" grid-list-md="grid-list-md">
        <v-layout row="row" wrap="wrap">
          <v-flex v-for="(c, index) of columns" :key="index" d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6">
            <component v-if="c.searchComponent || c.editComponent" :is="c.searchComponent || c.editComponent" :item="search" :restrict="false" :label="c.text" v-model="search[c.value]"></component>
            <v-text-field v-else-if="c.searchvalue" v-model="search[c.searchvalue]" :label="c.text" :placeholder="c.placeholder"></v-text-field>
            <v-text-field v-else v-model="search[c.value]" :label="c.text" :placeholder="c.placeholder"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row="row" wrap="wrap">
          <v-spacer></v-spacer>
          <div class="search-error">{{ errorMessage }}</div>
        </v-layout>
      </v-container>
    </div>
  </TransitionExpand>

</template>

<script>

import Vue from 'vue'
import TransitionExpand from '@/components/TransitionExpand'

export default {
  name: 'ItemSearch',
  components: {
    TransitionExpand
  },
  props: {
    enabled: {
      type: Boolean,
      default: false
    },
    search: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object
    }
  },
  data () {
    return {
      errorMessage: null,
      previousSearchData: null
    }
  },
  computed: {
    columns () {
      return this.options.columns
        .filter(c => c.searchable !== false)
        .sort((a, b) => {
          if (a.editPosition === b.editPosition) {
            return 0
          } else if (!a.editPosition) {
            return 1
          } else if (!b.editPosition) {
            return -1
          }
          return a.editPosition - b.editPosition
        })
    }
  },
  watch: {
    search: {
      handler (s) {
        if (!s) {
          this.search = {}
        }
        for (const param in s) {
          if (s[param] === null || s[param] === '') {
            Vue.delete(s, param)
          }
        }
        console.log('update search', JSON.stringify(s))
        this.$emit('update:search', s)
      },
      deep: true
    }
  }
}

</script>

<style lang="scss" scoped>

.elevation-4 {
  margin-bottom: 40px;
}

</style>



// WEBPACK FOOTER //
// src/components/common/ItemSearch.vue